import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig.js";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import GamificationSystem from "./GamificationSystem.js";
const StaffManagement = () => {
  const [staff, setStaff] = useState([]);
  const [newStaff, setNewStaff] = useState({ name: "", role: "", phone: "" });
  const [editingStaff, setEditingStaff] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const staffPerPage = 5;

  useEffect(() => {
    const fetchStaff = async () => {
      const staffCollection = collection(db, "staff");
      const staffSnapshot = await getDocs(staffCollection);
      setStaff(staffSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchStaff();
  }, []);

  const handleCreate = async () => {
    if (!newStaff.name || !newStaff.role || !newStaff.phone) return;
    await addDoc(collection(db, "staff"), {
      ...newStaff,
      createdBy: auth.currentUser.uid,
      createdAt: serverTimestamp(),
    });
    setNewStaff({ name: "", role: "", phone: "" });
  };

  const handleUpdate = async () => {
    if (!editingStaff) return;
    await updateDoc(doc(db, "staff", editingStaff.id), editingStaff);
    setEditingStaff(null);
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "staff", id));
  };

  const indexOfLastStaff = currentPage * staffPerPage;
  const indexOfFirstStaff = indexOfLastStaff - staffPerPage;
  const currentStaff = staff.slice(indexOfFirstStaff, indexOfLastStaff);

  return (
    <div>
      <h2>Gestión de Personal</h2>
      
      <div>
        <input
          type="text"
          className="form-control"
          placeholder="Nombre"
          value={newStaff.name}
          onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Rol"
          value={newStaff.role}
          onChange={(e) => setNewStaff({ ...newStaff, role: e.target.value })}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Teléfono"
          value={newStaff.phone}
          onChange={(e) => setNewStaff({ ...newStaff, phone: e.target.value })}
        />
        <button className="btn btn-primary" onClick={handleCreate}>Agregar</button>
      </div>

      {editingStaff && (
        <div>
          <h3>Editar Empleado</h3>
          <input
            type="text"
            className="form-control"
            placeholder="Nombre"
            value={editingStaff.name}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, name: e.target.value })
            }
          />
          <input
            type="text"
            className="form-control"
            placeholder="Rol"
            value={editingStaff.role}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, role: e.target.value })
            }
          />
          <input
            type="text"
            className="form-control"
            placeholder="Teléfono"
            value={editingStaff.phone}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, phone: e.target.value })
            }
          />
          <input
            type="text"
            className="form-control"
            placeholder="Habilidades"
            value={editingStaff.habilidades || ""}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, habilidades: e.target.value })
            }
          />
          <input
            type="text"
            className="form-control"
            placeholder="Debilidades"
            value={editingStaff.debilidades || ""}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, debilidades: e.target.value })
            }
          />
          <textarea
            className="form-control"
            placeholder="Notas"
            value={editingStaff.notas || ""}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, notas: e.target.value })
            }
          ></textarea>
          <input
            type="text"
            className="form-control"
            placeholder="Horario de trabajo"
            value={editingStaff.horarioTrabajo || ""}
            onChange={(e) =>
              setEditingStaff({ ...editingStaff, horarioTrabajo: e.target.value })
            }
          />
          <button className="btn btn-primary" onClick={handleUpdate}>Actualizar</button>
        </div>
      )}

      <table className="table table-striped">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Rol</th>
            <th>Horarios</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentStaff.map((employee) => (
            <tr key={employee.id}>
              <td>{employee.name}</td>
              <td>{employee.role}</td>
              <td>{employee.horarioTrabajo}</td>
              <td>
                <button className="btn btn-danger btn-sm" onClick={() => setEditingStaff(employee)}><i className="fa fa-edit"></i></button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(employee.id)}><i className="fa fa-trash"></i></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="btn btn-outline-secondary"
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        Anterior
      </button>
      <button className="btn btn-outline-secondary"
        disabled={indexOfLastStaff >= staff.length}
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        Siguiente
      </button>

      <GamificationSystem staff={staff} />
    </div>
  );
};

export default StaffManagement;
